let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("f39ay")).then(() => parcelRequire('f6DqK'));